import DatasourceTable from './DatasourceTable'
import SearchBy from './SearchBy'
export default {
  install(Vue) {
    Vue.component('DatasourceTable', DatasourceTable)
    Vue.component('SearchBy', SearchBy)
  },
}
